<template>
  <div class="upload-file">
    <el-upload
      ref="upload"
      action=""
      :before-upload="handleBeforeUpload"
      :file-list="fileList"
      :limit="limit"
      :on-error="handleUploadError"
      :on-exceed="handleExceed"
      :on-success="handleUploadSuccess"
      :on-change="changeFile"
      :show-file-list="showList"
      :headers="headers"
      :auto-upload="false"
      class="upload-file-uploader"
    >
      <!-- 上传按钮 -->
      <button class="fileBtn">
        点击上传
      </button>
      <!-- 上传提示 -->
      <div
        v-if="showTip"
        slot="tip"
        class="el-upload__tip"
      >
        <!-- <template v-if="fileSize">
          大小不超过 <b style="color: #f56c6c">{{ fileSize }}MB</b>
        </template> -->
        <template v-if="fileType">
          请上传格式为 <b style="color: #f56c6c">{{ fileType.join("/") }}</b>
        </template>
        的文件
      </div>
    </el-upload>

    <!-- 文件列表 -->
    <transition-group
      class="upload-file-list el-upload-list el-upload-list--text"
      name="el-fade-in-linear"
      tag="ul"
    >
      <li
        v-for="(file, index) in list"
        :key="file.uid"
        class="el-upload-list__item ele-upload-list__item-content"
      >
        <el-link
          :href="file.url"
          :underline="false"
          target="_blank"
        >
          <span class="el-icon-document"> {{ getFileName(file.name) }} </span>
        </el-link>
        <div class="ele-upload-list__item-content-action">
          <el-link
            :underline="false"
            type="danger"
            @click="handleDelete(index)"
          >
            删除
          </el-link>
        </div>
      </li>
    </transition-group>
  </div>
</template>

<script>
import { getToken } from '@/utils/auth';
export default {
  props: {
    // 值
    value: [String, Object, Array],
    // 大小限制(MB)
    fileSize: {
      type: Number,
      default: 5,
    },
    // 文件类型, 例如['png', 'jpg', 'jpeg']
    fileType: {
      type: Array,
      default: () => ['png', 'jpg', 'jpeg', 'pdf'],
    },
    // 是否显示提示
    isShowTip: {
      type: Boolean,
      default: true
    },
    // 文件个数
    limit:{
      type: Number,
      default: 1
    },
    // 展示上传文件
    showList: {
      type: Boolean,
      default: false
    },
    // 自定义字段
    custom: {
      type: Object,
      default:() => {}
    },
    // 回显文件地址
    fileUrl: {
      type:String,
      default:() => ''
    },
    // 上传请求
    uploadReq: {
      type:Function,
      default:()=>{
        return function(){};
      }
    }
  },
  data() {
    return {
      headers: {
        Authorization: 'Bearer ' + getToken(),
      },
      fileList: []
    };
  },
  computed: {
    // 是否显示提示
    showTip() {
      return this.isShowTip && (this.fileType || this.fileSize);
    },
    // 列表
    list() {
      let temp = 1;
      if (this.value) {
        // 首先将值转为数组
        const list = Array.isArray(this.value) ? this.value : [this.value];
        // 然后将数组转为对象数组
        return list.map((item) => {
          if (typeof item === 'string') {
            item = { name: item, url: item };
          }
          item.uid = item.uid || new Date().getTime() + temp++;
          return item;
        });
      } else {
        return [];
      }
    },
  },
  watch:{
    fileUrl(val) {
      if (val) {
        let list = val.split(',');
        let newList = [];
        list.map(url=>{
          let obj = {};
          let len = url.split('/').length;
          let name = url.split('/')[len-1];
          obj.name = name;
          obj.url = url;
          newList.push(obj);
        });
        this.fileList = newList;
      }
    }
  },
  created() {
    this.fileList = this.list;
  },
  methods: {
    // 上传前校检格式和大小
    handleBeforeUpload(file) {
      // 校检文件类型
      if (this.fileType) {
        let fileExtension = '';
        if (file.name.lastIndexOf('.') > -1) {
          fileExtension = file.name.slice(file.name.lastIndexOf('.') + 1);
        }
        const isTypeOk = this.fileType.some((type) => {
          if (file.type.indexOf(type) > -1) return true;
          if (fileExtension && fileExtension.indexOf(type) > -1) return true;
          return false;
        });
        if (!isTypeOk) {
          this.$message.error(`文件格式不正确, 请上传${this.fileType.join('/')}格式文件!`);
          return false;
        }
      }
      // 校检文件大小
      // if (this.fileSize) {
      //   const isLt = file.size / 1024 / 1024 < this.fileSize;
      //   if (!isLt) {
      //     this.$message.error(`上传文件大小不能超过 ${this.fileSize} MB!`);
      //     return false;
      //   }
      // }
      // return true;
    },
    // 文件个数超出
    handleExceed() {
      this.$message.error(`只允许上传${this.limit}个文件`);
    },
    // 上传失败
    handleUploadError(err) {
      this.$message.error('上传失败, 请重试');
    },
    // 上传成功回调
    handleUploadSuccess(res, file) {
      this.$message.success('上传成功');
      this.$emit('input', res.url);
    },
    // 删除文件
    handleDelete(index) {
      this.fileList.splice(index, 1);
      this.$emit('input', '');
    },
    // 获取文件名称
    getFileName(name) {
      if (name.lastIndexOf('/') > -1) {
        return name.slice(name.lastIndexOf('/') + 1).toLowerCase();
      } else {
        return '';
      }
    },
    changeFile(file, filist) {
      this.fileList = filist;
      this.$emit('fileChange',this.fileList);
    },
    submit () {
      const formData = new FormData();
      console.log(this.fileList);
      this.fileList.forEach(item => {
          formData.append('files', item['raw']);
      });
      return new Promise((resolve,reject) => {
        this.uploadReq(this.custom, formData).then( res => {
          if (res.code===0) {
            resolve();
          }else {
            reject();
          }
        }).catch(err => {
          reject(err);
        });
      });
      
    },
  },
};
</script>

<style scoped lang="scss">
.upload-file {
  .upload-file-uploader {
    text-align: center;
  }
  .fileBtn {
    width: 160px;
    height: 48px;
    font-size: 20px;
    cursor: pointer;
    background: #0EBD35;
    border-radius: 4px;
    color: #fff;
  }
  .el-upload__tip {
    font-size: 12px;
    color: #17ECFE;
  }
  ::v-deep.el-upload-list__item:hover {
    background-color:transparent;
  }
}
::v-deep.el-upload-list {
  margin-top: 30px;
  max-width: 350px;
  .el-upload-list__item-name {
    color: #0EBD35;
  }
  .el-upload-list__item-name [class^="el-icon"] {
    color: #0EBD35;
  }
}
.upload-file-uploader {
  margin-bottom: 5px;
}
.upload-file-list .el-upload-list__item {
  border: 1px solid #e4e7ed;
  line-height: 2;
  margin-bottom: 10px;
  position: relative;
}
.upload-file-list .ele-upload-list__item-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: inherit;
}
.ele-upload-list__item-content-action .el-link {
  margin-right: 10px;
}
</style>